// extracted by mini-css-extract-plugin
export default {"socialMediaButtonGroup":"SocialMediaButtons-module__socialMediaButtonGroup___2z5x9","socialMediaImg":"SocialMediaButtons-module__socialMediaImg___vjxOL"};